"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var NsHeader = function (_a) {
    var _b = _a.logo, logo = _b === void 0 ? 'https://www.britishgas.co.uk/nucleus/images/logo.svg' : _b, _c = _a.alt, alt = _c === void 0 ? 'British Gas' : _c, hideLinks = _a.hideLinks, noRootLink = _a.noRootLink, primary = _a.primary, secondary = _a.secondary, children = _a.children, skipSubdomain = _a.skipSubdomain, quickLinks = _a.quickLinks, secondaryBanner = _a.secondaryBanner, menuBanner = _a.menuBanner, rest = __rest(_a, ["logo", "alt", "hideLinks", "noRootLink", "primary", "secondary", "children", "skipSubdomain", "quickLinks", "secondaryBanner", "menuBanner"]);
    var headerNode = (0, react_1.useRef)(null);
    return (react_1.default.createElement("ns-header", __assign({ ref: headerNode, logo: logo, alt: alt, "hide-links": hideLinks, "no-root-link": noRootLink, primary: JSON.stringify(primary), "skip-subdomain": skipSubdomain, secondary: JSON.stringify(secondary), "quick-links": JSON.stringify(quickLinks), "secondary-banner": JSON.stringify(secondaryBanner), "menu-banner": JSON.stringify(menuBanner) }, rest), children));
};
exports.default = NsHeader;
